'use strict';
import get from 'lodash/get';
import React from 'react';
import * as T from 'prop-types';
import {NavigationBar, navigationBarLinkProps} from '../../../components/views/NavigationBar';
import {I18nComponent} from '../../../core-utilities/react-i18n/I18nComponent';
import {Link} from '../../../app/components/Link';
import {TaskType, isTaskType} from '../../enums/TaskType';
import {assetTasksStates, projectTasksStates, templateTasksStates} from '../../router-config';


export function BaseTaskNavigationBarView(props) {
  const routerStates = getRouterState(props.taskType);
  const toParams = props.navState && props.navState.currentParams;

  return (
    <NavigationBar>
      <Link
        {...navigationBarLinkProps}
        navState={props.navState}
        to={routerStates.requirements}
        toParams={toParams}
      >
        {props.requirementsTitle}
      </Link>
      {routerStates.timerLog ? (
        <Link
          {...navigationBarLinkProps}
          navState={props.navState}
          to={routerStates.timerLog}
          toParams={toParams}
        >
          {props.timerLogTitle}
        </Link>
      ) : null}
      <Link
        {...navigationBarLinkProps}
        navState={props.navState}
        to={routerStates.activityFeed}
        toParams={toParams}
      >
        {props.activityFeedTitle}
      </Link>
      {showMemberAccess(props.taskType, props.target) ? (
        <Link
          {...navigationBarLinkProps}
          navState={props.navState}
          onClick={props.onShowManageAccess}
        >
          {props.manageAccessTitle}
        </Link>
      ) : null}
    </NavigationBar>
  );
}

BaseTaskNavigationBarView.propTypes = {
  className: T.string,
  taskType: isTaskType.isRequired,
  target: T.object,

  requirementsTitle: T.string,
  timerLogTitle: T.string,
  activityFeedTitle: T.string,
  manageAccessTitle: T.string,

  onShowMemberAccess: T.func,
};

export const TaskNavigationBarView = I18nComponent(BaseTaskNavigationBarView, [
  {code: 'tasks.views.requirements.title', prop: 'requirementsTitle'},
  {code: 'tasks.views.timer.title', prop: 'timerLogTitle'},
  {code: 'tasks.views.activity.title', prop: 'activityFeedTitle'},
  {code: 'tasks.views.access.title', prop: 'manageAccessTitle'},
]);

function getRouterState(taskType) {
  switch (taskType) {
    case TaskType.ASSET:
      return assetTasksStates;

    case TaskType.PROJECT:
      return projectTasksStates;

    case TaskType.TEMPLATE:
      return templateTasksStates;
  }
}

function showMemberAccess(taskType, target) {
  switch (taskType) {
    case TaskType.PROJECT:
    case TaskType.TEMPLATE:
      return true;

    case TaskType.ASSET:
      return target && !get(target, 'task.id');
  }
}



// WEBPACK FOOTER //
// ./src/js/tasks/components/TaskNavigationBar/TaskNavigationBarView.js